export default Object.freeze({
    COLORS: {
        PRIMARY_500: '#3091F6',
        PRIMARY_200: '#C3DFFC',
        POSITIVE_500: '#13C7C8',
        SWITCHER_OFF: '#828D9A',
        SWITCHER_ON_DISABLED: '#A2E4E5',
        LIGHT_100: '#F9FAFB',
        LIGHT_200: '#F3F5F7',
        LIGHT_500: '#E1E6EB',
        LIGHT_600: '#c2cdd7',
        LIGHT_700: '#95A6B8',
        LIGHT_800: '#678099',
        LIGHT_900: '#52677b',
        NEUTRAL_700: '#FF9403',
        NEUTRAL_500: '#ffbb5f',
        NEGATIVE_500: '#e1174c',
        NEGATIVE_700: '#da564f',
        DARK_300: '#172d4c',
        DARK_500: '#0B1625',
        PURPLE: '#9999ff',
        TEAL: '#04ccd7',
        WHITE: '#FFF'
    },
    COLORS_V2: {
        DARK_100: '#ced0e0',
        DARK_200: '#4c548e',
        DARK_300: '#313d91',
        DARK_400: '#212791',
        DARK_500: '#0d148c',
        DARK_600: '#021074',
        DARK_700: '#1d1c64',
        PRIMARY_100: '#e2eeff',
        PRIMARY_200: '#c9dfff',
        PRIMARY_300: '#96c0ff',
        PRIMARY_400: '#68a5ff',
        PRIMARY_500: '#3083ff',
        PRIMARY_600: '#005be2',
        SECONDARY_100: '#e1fbfc',
        SECONDARY_200: '#bff2f5',
        SECONDARY_300: '#91e2e7',
        SECONDARY_500: '#00ccd7',
        LIGHT_100: '#f7f8f9',
        LIGHT_200: '#f0f1f2',
        LIGHT_300: '#e5e7e9',
        LIGHT_400: '#dddfe1',
        LIGHT_500: '#d2d5d8',
        LIGHT_600: '#b7bbc0',
        LIGHT_700: '#a9afb4',
        LIGHT_800: '#8e959d',
        LIGHT_900: '#7b838c',
        WHITE: '#ffffff',
        NEUTRAL_100: '#fff8e2',
        NEUTRAL_200: '#ffe0a3',
        NEUTRAL_500: '#ffb424',
        NEUTRAL_700: '#fea222',
        NEUTRAL_900: '#d8840d',
        NEGATIVE_100: '#ffefee',
        NEGATIVE_200: '#ffcbce',
        NEGATIVE_300: '#ff9b96',
        NEGATIVE_400: '#ff827c',
        NEGATIVE_500: '#ff6a63',
        NEGATIVE_600: '#ec5d56',
        NEGATIVE_700: '#da564f',
        POSITIVE_100: '#daf5ec',
        POSITIVE_200: '#b4e9d2',
        POSITIVE_300: '#78ddbc',
        POSITIVE_400: '#5cd6ad',
        POSITIVE_500: '#22c891',
        POSITIVE_600: '#1eb281',
        POSITIVE_700: '#1b9c71'
    },
    GENERAL_SERVICE_ERROR: 'We had a problem, please try again.',
    ADUNIT_TO_NAME: {
        rewardedVideo: 'Rewarded Video',
        interstitial: 'Interstitial',
        offerWall: 'Offerwall',
        banner: 'Banner'
    },
    ADUNIT_TO_SHORT_NAME: {
        rewardedVideo: 'rv',
        interstitial: 'is',
        offerWall: 'ow',
        banner: 'bn'
    },
    TAG_TYPE_TO_NAME: {
        0: 'Tag',
        1: 'PMP'
    },
    PROVIDER_IDS: {
        FACEBOOK: 9939,
        IRONSOURCE: 9899
    },
    PROVIDER_NAMES: {
        IRONSOURCE: 'ironSource'
    },
    UNIT_NAMES: {
        d: 'Day',
        h: 'Hour'
    },
    RESPONSIVE_WIDTH_STEPS: {
        LARGE_LAPTOP: 1919,
        MOBILE: 1023
    },
    AB_OBJ: [{
        id: 1,
        key: 'any',
        displayText: 'All'
    },
    {
        id: 2,
        key: 'a',
        displayText: 'A'
    },
    {
        id: 3,
        key: 'b',
        displayText: 'B'
    }]
});
